const context = new AudioContext();
const sounds = new Map<string, AudioBuffer>();

async function loadSound(url: string, name: string) {
	if (sounds.has(name)) return; // Already loaded
	const buffer = await fetch(url)
		.then((res) => res.arrayBuffer())
		.then((buf) => context.decodeAudioData(buf));

	sounds.set(name, buffer);
}

function playSound(name: string) {
	if (localStorage.case_prefs_sounds === "off") return;

	const sound = sounds.get(name);

	if (sound) {
		const source = context.createBufferSource();
		source.buffer = sound;
		source.connect(context.destination);
		source.start();
	}
}

// Load relevant sounds
void loadSound("/sounds/click.wav", "click");
void loadSound("/sounds/power-appear.wav", "power-appear");
void loadSound("/sounds/power-activate.wav", "power-activate");
void loadSound("/sounds/tick.wav", "tick");

export const SoundManager = {
	context,
	sounds,
	loadSound,
	playSound,
};
